import ReactGA from 'react-ga';
import gaConfig from './config';
import { EXPERIENCE_DOMAIN_CONFIG } from '../constants';

export class GA {
  static GAInstance: typeof ReactGA | null;

  static getGAInstance(): typeof ReactGA | null {
    if (!this.GAInstance) {
      const tracker = this.resolveTracker();
      if (tracker) {
        this.GAInstance = ReactGA;
        this.GAInstance.initialize(tracker);
        this.GAInstance.set({ anonymizeIp: true });
      } else {
        this.GAInstance = null;
      }
    }
    return this.GAInstance;
  }

  static resolveTracker(): string | false {
    const { hostname } = window.location;
    const hosts = hostname as EXPERIENCE_DOMAIN_CONFIG;
    if (hostname && typeof hostname === 'string') {
      if (typeof gaConfig[hosts] === 'object' && gaConfig[hosts].active) {
        return gaConfig[hosts].tracker;
      } else {
        return false;
      }
    }
    return false;
  }
}
